import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-islamic-calendar',
  imports: [PagePlaceholderComponent],
  templateUrl: './islamic-calendar.component.html',
  styleUrl: './islamic-calendar.component.scss'
})
export class IslamicCalendarComponent {
  protected readonly icon = '📆';
  protected readonly pageTitle = 'pages.islamic_calendar.title';
  protected readonly subtitle = 'pages.islamic_calendar.subtitle';
}
